import {
  ArcElement,
  BarController,
  BarElement,
  CategoryScale,
  Colors,
  DoughnutController,
  Filler,
  Legend,
  LinearScale,
  LineController,
  LineElement,
  PointElement,
  Tooltip,
} from 'chart.js';

export const wooChartRegisterables = [
  DoughnutController,
  BarController,
  LineController,
  ArcElement,
  BarElement,
  LineElement,
  PointElement,
  CategoryScale,
  LinearScale,
  Colors,
  Filler,
  Legend,
  Tooltip,
];
